// extracted by mini-css-extract-plugin
export default {"operations":"style_operations__OUmuo","operation":"style_operation__MOUD4","loading":"style_loading__yKieF","drag-view":"style_drag-view__i-WMS"};